module.exports = __webpack_public_path__ + "img/upload_btn.c571de10.png";